import { createURLState } from '@/shared/lib/hooks/use-url-state';

export const useDetailsState = createURLState<{ root_task_id: string }>();